import { PickListItem, JsonItem, AppUserGroupCommittee, AppUserExtended, TeamsAccessResponse } from "../list-management.objects"; 
import { SpecialCaseEntity } from "../list-management.form-sections";
import _ from "lodash";

declare var $: any;
export class UserGroupSelector implements SpecialCaseEntity {
    id: string;
    sectionId: string;
    propertyName: string;
    groupPickListName: string;
    rolePickListName: string;

    isRequired: boolean;
    displayName: string;

    groupList: PickListItem[];
    roleList: PickListItem[];

    groupTable: any;
    initialGroups: AppUserGroupCommittee[];
    addedGroups: AppUserGroupCommittee[];

    showTeamsAccess: boolean = false;
    currentAppUser: AppUserExtended = null;


    constructor(id: string, propteryName: string, groupListName: string, additionalPickLists: string[], displayName: string, isRequired: boolean, showTeamsAccess: boolean = false) {
        this.id = id;
        this.sectionId = `user-group-${this.id}`;
        this.propertyName = propteryName;
        this.groupPickListName = groupListName;
        this.rolePickListName = additionalPickLists.find(name => name.includes("role"));
        this.addedGroups = [];
        this.initialGroups = [];
        this.displayName = displayName;
        this.isRequired = isRequired;
        this.showTeamsAccess = showTeamsAccess;
    }

    generateHtml(): string {
        let requiredClass = "";
        if (this.isRequired) requiredClass = "required";
        let displayNameHtml = "";
        if (this.displayName) {
            displayNameHtml = `<div class="group-selector-label"><label for="" class="${requiredClass}">${this.displayName}</label></div>`
        }
        let teamsAccessSection = "";
        if (this.showTeamsAccess) {
            teamsAccessSection = `
                <div class="teams-access-section col-12 py-3" id="teams-access-block-${this.id}"> 
                    <div class="d-flex justify-content-between mb-2">
                        <div class="font-size14 font-weight-bold">Check Teams Access</div>
                        <button class="revampp-white-btn check-teams-btn">Refresh</button>
                    </div>
                    <div id="${this.id}-teams-list">
                        <p>Use the button below to check if the user has been added to the appropriate Teams channels. After the button has been clicked, if the user has not been added to the Team channel, click on the name of the group to access the appropriate channel and add the user. After adding the user to the team, click on the 'Refresh' button to update this list and verify. </p>
                        <button class="revampp-blue-btn check-teams-btn">Check Teams Access</button>
                    </div>
                </div>
            `
        }

        let html = `
            ${displayNameHtml}
            <p class="group-selector-description">Use the group membership tool below to add any ReVAMPP groups. To add a group, select a group and membership role, then click "Add Group". To remove a group, expand it in the list by clicking on it, then click "Remove Group".</p>
            <div class="user-affiliation-selection-block mb-4" id="user-group-${this.id}">
                <div class="reset-section-block d-flex justify-content-between align-items-center py-2 px-3">
                    <div id="user-display-title-${this.id}" class="reset-section-title d-none">
                        
                    </div>
                    <div class="reset-user-affiliation">
                        <a id="reset-user-group-btn-${this.id}" class="btn btn-secondary revampp-white-btn font-size14">
                            Reset
                        </a>
                    </div>
                </div>
                <div class="add-user-affiliation-block py-3">
                    <div class="row px-3">
                        <div class="col-md-6 col-12 affiliation-block-form">
                            <div class="row mb-2">
                                <div class="form-group col">
                                    <label class="mb-0">ReVAMPP Group/Committee:</label>
                                    <select class="selectpicker dropdown list-management-dropdown" id="revampp-group-select-${this.id}" title="-- Select a Group/Committee --" data-width="100%" data-container="body" data-size="5">
                                        
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="form-group col">
                                    <label class="mb-0">Membership Role:</label>
                                    <select class="selectpicker dropdown list-management-dropdown" id="revampp-group-role-select-${this.id}" title="-- Select a Role --" data-width="100%" data-container="body" data-size="5">
                                        
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col-auto">
                                    <a class="btn btn-small revampp-blue-btn text-decoration-none add-group-btn disabled" id="add-group-btn-${this.id}">+ Add Group</a>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-12 affiliation-block-list mt-md-0 mt-3">
                            <div>
                                <div class="mb-1">
                                    <span class="font-weight-bold">Added Groups: </span><span id="added-groups-count-${this.id}">0</span>
                                </div>
                                <div class="revampp-group-list-section">

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                ${teamsAccessSection}
            </div>            
            `
        return html;
    }

    initialize(pickLists: JsonItem[], entityArr: any[]): void {
        // Create Lists
        this.groupList = [];
        this.roleList = [];

        let foundGroupList = pickLists.find(list => list.Id == this.groupPickListName);
        let foundRoleList = pickLists.find(list => list.Id == this.rolePickListName);

        if (!foundGroupList || !foundRoleList) return;

        this.groupList = foundGroupList.Json;
        this.roleList = foundRoleList.Json;

        // Dropdown for Roles + Groups
        let groupArr: string[][] = [];
        this.groupList.forEach(group => groupArr.push([group.Value, group.Id.toString()]));
        let roleArr: string[][] = [];
        this.roleList.forEach(role => roleArr.push([role.Value, role.Id.toString()]));
        this.generateDropdown(`revampp-group-select-${this.id}`, groupArr);
        this.generateDropdown(`revampp-group-role-select-${this.id}`, roleArr);

        //initialize table
        this.clearGroupList();

        // initialize Search functionality
        this.initializeSearchTool();

        // Store Additional User Info
        if (entityArr.length > 0) {
            // groups are only done with one user
            this.currentAppUser = entityArr[0];
        }

        this.updateDisplayUser();

        // Check teams access btns
        $(`#teams-access-block-${this.id}`).find(".check-teams-btn").on('click', async () => {
            await this.getTeamsMembership();
        })
    }

    updateDisplayUser(): void {
        let displayBlock: JQuery<HTMLElement> = $(`#user-display-title-${this.id}`);
        displayBlock.addClass("d-none");

        if (this.currentAppUser) {
            let name = `${this.currentAppUser.AppUser.FirstName} ${this.currentAppUser.AppUser.LastName}`;
            displayBlock.text(name);
            displayBlock.removeClass("d-none");
        }
    }

    getValue(): any {
        return this.addedGroups;
    }

    validate(): boolean {
        return true;
    }

    getDisplayRole(roleId: number): string {
        let returnVal = "";
        let foundRole = this.roleList.find(role => role.Id == roleId);
        if (foundRole) {
            returnVal = foundRole.Value;
        }
        return returnVal;
    }

    getDisplayGroup(groupId: number): string {
        let returnVal = "";
        let foundGroup = this.groupList.find(group=> group.Id == groupId);
        if (foundGroup) {
            returnVal = foundGroup.Value;
        }
        return returnVal;
    }

    updateStoredValues(entityArray: any[]): void {
        // This isn't going to work for mulitple items;
        if (entityArray.length <= 0) return;
        let targetEntity = entityArray[0];
        let initialValues = _.get(targetEntity, this.propertyName);

        this.initialGroups = _.cloneDeep(initialValues);
        this.addedGroups = _.cloneDeep(initialValues);
        this.updateGroupsList();
    }

    checkChanged(): boolean {
        if (this.initialGroups.length != this.addedGroups.length) {
            return true;
        }

        let isChanged = false;
        this.initialGroups.forEach(group => {         
            let foundGroup = this.addedGroups.some(addedGroup => addedGroup.GroupId == group.GroupId && addedGroup.GroupRoleId == group.GroupRoleId);
            if (!foundGroup) {
                isChanged = true;
            }
        });

        return isChanged;
    }

    clearGroupList(): void {
        $(`#${this.sectionId}`).find(".revampp-group-list-section").empty();
    }

    updateGroupsList(): void {
        this.clearGroupList();
        let groupListHtml = "";
        for (let i = 0; i < this.addedGroups.length; i++) {
            let currentGroup: AppUserGroupCommittee = this.addedGroups[i];


            let expandContent = `
                <div id="group-list-collapse-${i}" class="collapse p-1">
                    <div>
                        <b>Group/Committee</b>: ${this.getDisplayGroup(currentGroup.GroupId)} 
                    </div>
                    <div>
                        <b>Member Role</b>: ${this.getDisplayRole(currentGroup.GroupRoleId)} 
                    </div>
                    <div class="mt-2">
                        <a class="btn btn-small revampp-white-btn text-decoration-none delete-group-btn" id="delete-group-btn-${i}">Remove Group</a>
                    </div>
                </div>
            `

            groupListHtml += `
                <div class="affiliation-list-item">
                    <div class="affiliation-item-block collapsed" data-toggle="collapse" data-target="#group-list-collapse-${i}">
                        <div class="affiliation-block-title">
                            ${this.getDisplayGroup(currentGroup.GroupId)}
                        </div>
                    </div>
                    ${expandContent}
                </div>
            `
        }

        $(`#${this.sectionId}`).find(".revampp-group-list-section").html(groupListHtml);
        $(`#added-groups-count-${this.id}`).text(this.addedGroups.length);

        $(`#${this.sectionId}`).find(".delete-group-btn").off().on("click", (e) => {
            let elementId = $(e.currentTarget).attr("id");
            let arrayIndex: number = parseInt(elementId.replace("delete-group-btn-", ""));
            if (arrayIndex != NaN) {
                this.addedGroups.splice(arrayIndex, 1);
                this.updateGroupsList();
            }
        })
    }

    initializeSearchTool(): void {
        // Reset Dropdowns
        $(`#reset-user-group-btn-${this.id}`).on('click', (e) => {
            this.clearValidation();
            this.resetDropdowns();
        });


        $(`#add-group-btn-${this.id}`).on('click', () => {
            // Validate
            let isValid: boolean = this.validateGroupForm();
            if (!isValid) return;

            // Get Group
            let groupId = parseInt($(`#revampp-group-select-${this.id}`).val().toString());
            let roleId = parseInt($(`#revampp-group-role-select-${this.id}`).val().toString());

            if (groupId == NaN || roleId == NaN) {
                return;
            }

            let newGroup: AppUserGroupCommittee = {
                Id: 0,
                AppUserId: 0,
                GroupRoleId: roleId,
                GroupId: groupId
            }

            // Add Group to List of Groups (no duplicates)
            let foundGroup = this.addedGroups.find(group => group.GroupRoleId == newGroup.GroupRoleId && group.GroupId == newGroup.GroupId);
            if (!foundGroup) {
                this.addedGroups.push(newGroup);
            }

            // Update Added Groups List
            this.updateGroupsList();
            this.resetDropdowns();
            this.clearValidation();
        });

        $(`#revampp-group-select-${this.id}`).on("changed.bs.select", () => {
            let roleSelected = $(`#revampp-group-role-select-${this.id}`).val();
            let groupSelected = $(`#revampp-group-select-${this.id}`).val();

            if (!roleSelected || !groupSelected) {
                $(`#add-group-btn-${this.id}`).addClass("disabled");
            }
            else {
                $(`#add-group-btn-${this.id}`).removeClass("disabled");
            }
        });

        $(`#revampp-group-role-select-${this.id}`).on("changed.bs.select", () => {
            let roleSelected = $(`#revampp-group-role-select-${this.id}`).val();
            let groupSelected = $(`#revampp-group-select-${this.id}`).val();

            if (!roleSelected || !groupSelected) {
                $(`#add-group-btn-${this.id}`).addClass("disabled");
            }
            else {
                $(`#add-group-btn-${this.id}`).removeClass("disabled");
            }
        })
    }

    validateGroupForm(): boolean {
        let isValid = true;

        // Role
        let roleSelected = $(`#revampp-group-role-select-${this.id}`).val();
        if (!roleSelected) {
            $(`#revampp-group-role-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
            isValid = false;
        }
        else {
            $(`#revampp-group-role-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-invalid").addClass("is-valid");
        }

        // Group
        let groupSelected = $(`#revampp-group-select-${this.id}`).val();
        if (!groupSelected) {
            $(`#revampp-group-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").addClass("is-invalid");
            isValid = false;
        }
        else {
            $(`#revampp-group-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-invalid").addClass("is-valid");
        }

        return isValid;
    }

    clearValidation() {
        $(`#revampp-group-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").removeClass("is-invalid");
        $(`#revampp-group-role-select-${this.id}`).siblings(".dropdown-toggle").removeClass("is-valid").removeClass("is-invalid");
    }

    resetDropdowns() {
        $(`#revampp-group-select-${this.id}`).val("").trigger("change");
        $(`#revampp-group-role-select-${this.id}`).val("").trigger("change");
    }

    generateDropdown(dropdownId: string, options: string[][]): void {
        // Remove any previous options
        $(`#${dropdownId}`).find("option").remove();

        $(`#${dropdownId}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });
        if (options != undefined) {
            options.sort((x1: string[], x2: string[]) => {
                if (x1[0].startsWith("-") && !x2[0].startsWith("-")) {
                    return 1;
                }
                else if (x2[0].startsWith("-") && !x1[0].startsWith("-")) {
                    return -1;
                }
                else {
                    return x1[0].localeCompare(x2[0]);
                }
            });
            options.forEach((element: string[]) => {
                $(`#${dropdownId}`).append(new Option(element[0], element[1], false, false))
            })
        }

        $(`#${dropdownId}`).selectpicker("refresh");
    }

    getDisplayValue(indexVal = -1): string {
        return "";
    }

    async getTeamsMembership(): Promise<any> {
        // Get Member Email
        let userEmail = this.currentAppUser.AppUser.Email;
        if (userEmail == null || userEmail == "") {
            // For New Users you can check the field
            let checkFormUserEmail = <string>$(`#add-user-email`).val();
            if (checkFormUserEmail == "") {
                $(`#${this.id}-teams-list`).empty().html(
                    `<div class="text-center">User Email Not Found</div>`
                );
                return;
            }
            else {
                userEmail = checkFormUserEmail;
                this.currentAppUser.AppUser.Email = checkFormUserEmail;
            }
        }

        // Update Group List
        this.currentAppUser.AppUserGroupList = this.addedGroups;
        if (this.addedGroups.length == 0) {
            $(`#${this.id}-teams-list`).empty().html(
                `<div class="text-center">No Groups Specified</div>`
            );
            return;
        }

        // Show Loading 
        $(`#${this.id}-teams-list`).empty().html(
            `<div class="d-flex justify-content-center align-items-center mb-3">
                <div class="mr-3 font-size18" style="font-weight: 500;">Checking Membership</div>
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>`
        );

        // Send Request
        let result: any
        try {
            result = await $.ajax({
                url: `/secure/list-management/list-management?handler=GetMembership`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify([this.currentAppUser]) },
            })
            let teamsAccessList: TeamsAccessResponse[] = <TeamsAccessResponse[]>result;
            let teamsMembershipContent = this.getTeamsMembershipDisplay(teamsAccessList);
            $(`#${this.id}-teams-list`).empty().html(teamsMembershipContent);
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }      
    }

    getTeamsMembershipDisplay(accessResponse :TeamsAccessResponse[]): string {
        let returnContent = "";
        accessResponse.forEach(team => {
            let accessIcon = `<i class="fa-solid fa-circle-xmark fa-lg error-icon"></i>`;
            if (team.IsMember) {
                accessIcon = `<i class="fa-solid fa-circle-check fa-lg success-icon"></i>`
            }

            returnContent += `
                <div class="team-access-card d-flex justify-content-between mb-2">
                    <div class="d-flex">
                        <div class="team-access-icon">${accessIcon}</div>
                        <div class="team-access-title pl-2"><a href="${team.TeamLink}" target="_blank">${team.TeamDisplayName}</a></div>
                    </div>
                </div>
            `
        });

        
        return `
            <div>
                <p>Check the list below to see if the user has been added to the appropriate Teams channels. If the user has not been added to the Team channel, click on the name of the group to access the appropriate channel and add the user. After adding the user to the team, click on the 'Refresh' button to update this list and verify.</p>
                ${returnContent}
            </div>
        `;

    }
}